import { Editor, Element } from "slate";

import ElementType from "../../type/slate/ElementType";

const withDynamicVariables = (editor: Editor): Editor => {
  const { isInline, isVoid } = editor;

  editor.isInline = (element: Element) => {
    return Element.isElementType(element, ElementType.DYNAMIC_VARIABLE) || isInline(element);
  };

  editor.isVoid = (element: Element) => {
    return Element.isElementType(element, ElementType.DYNAMIC_VARIABLE) || isVoid(element);
  };

  return editor;
};

export default withDynamicVariables;
